<div class="masonry-shell" [ngClass]="masonryShellClasses">
  @if (showGalleryHeading || gallery.intro) {
  <div class="masonry-heading">
    @if (showGalleryHeading) {
    <div class="masonry-heading__eyebrow">
      <span class="masonry-heading__eyebrow-num">{{ displayOrderLabel }}</span>
      <span class="masonry-heading__eyebrow-sep">—</span>
      <span class="masonry-heading__eyebrow-label">{{ headerLabel || 'Gallery' }}</span>
    </div>
    @if (gallery.title) {
    <h3 class="masonry-heading__title">{{ gallery.title }}</h3>
    }
    }
    @if (gallery.intro) {
    <p class="masonry-heading__intro">{{ gallery.intro }}</p>
    }
  </div>
  }

  <div class="masonry-grid" [ngClass]="masonryGapClass">
    @for (item of items; track item._trackKey; let i = $index) {
    <div
      #cellRef
      [ngClass]="item._cellClass"
      [style.--masonry-reveal-delay]="getRevealDelay(i)">
      @if (item._isText) {
      <article class="masonry-text-card">
        @if (item.eyebrow) {
        <span class="masonry-text-card__eyebrow">{{ item.eyebrow }}</span>
        }
        @if (item.title) {
        <h4 class="masonry-text-card__title">{{ item.title }}</h4>
        }
        @if (item.body || item.caption) {
        <p class="masonry-text-card__body">{{ item.body || item.caption }}</p>
        }
      </article>
      } @else if (item._isVideo) {
      <figure class="masonry-figure">
        <video
          class="masonry-media"
          playsinline
          preload="metadata"
          [attr.playsinline]="''"
          [attr.webkit-playsinline]="''"
          [attr.controls]="null"
          [attr.controlsList]="'nodownload noplaybackrate noremoteplayback'"
          [loop]="true"
          [poster]="item._posterUrl"
          [defaultMuted]="item.autoplay ? true : (item.muted ?? true)"
          [muted]="item.autoplay ? true : (item.muted ?? true)"
          [autoplay]="item.autoplay ?? false"
          [appLazyVideoSource]="item._mediaUrl"
        >
        </video>
        @if (item.caption && item._captionMode !== 'hidden') {
        <figcaption
          class="masonry-figure__caption"
          [class.masonry-figure__caption--below]="item._captionMode === 'below'">
          {{ item.caption }}
        </figcaption>
        }
      </figure>
      } @else {
      <figure
        class="masonry-figure masonry-figure--clickable"
        role="button"
        tabindex="0"
        (click)="openAt(i)"
        (keydown.enter)="openAt(i)"
        (keydown.space)="openAt(i); $event.preventDefault()">
        <img
          [src]="item._imageSrc"
          [attr.srcset]="item._imageSrcSet || null"
          sizes="(max-width: 767px) calc(100vw - 2rem), (max-width: 1023px) calc(50vw - 1.5rem), (max-width: 1440px) calc(100vw - 4rem), 86rem"
          [alt]="item.alt || item.caption || ('Gallery image ' + (i + 1))"
          class="masonry-media"
          [attr.loading]="i === 0 ? 'eager' : 'lazy'"
          decoding="async"
          [attr.fetchpriority]="i === 0 ? 'high' : 'auto'"
        />
        <span class="masonry-figure__zoom" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
        </span>
        @if (item.caption && item._captionMode !== 'hidden') {
        <figcaption
          class="masonry-figure__caption"
          [class.masonry-figure__caption--below]="item._captionMode === 'below'">
          {{ item.caption }}
        </figcaption>
        }
      </figure>
      }
    </div>
    }
  </div>

  @if (lightbox.isOpen) {
    <app-lightbox
      [items]="items"
      [activeIndex]="lightbox.index"
      [showThumbnails]="showLightboxThumbnails"
      [accentColor]="gallery.lightboxAccentColor ?? null"
      [analyticsLayout]="gallery.layout"
      (closeLightbox)="onLightboxClose()"
      (indexChange)="onLightboxIndexChange($event)">
    </app-lightbox>
  }
</div>
